<template lang="html">
    <entity-page v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light rounded @click="back()"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save()"></z-icon-button>
        </template>
        <div slot="default">
            <z-input 
                v-model="group.name" v-bind:disabled="progress" label="Название" 
                v-bind:error="errors.first('name')" name="name" id="name" v-validate="{'required': true, 'min': 3}"
                data-vv-name="name" v-bind:data-vv-as="' '"
            ></z-input>

            <z-input 
                v-model="group.code" v-bind:disabled="progress" label="Символьный код" 
                v-bind:error="errors.first('code')" name="code" id="code" v-validate="{'required': true, 'min': 3}"
                data-vv-name="code" v-bind:data-vv-as="' '"
            ></z-input>

            <z-text-area 
                v-model="group.description" v-bind:disabled="progress" label="Описание" 
                v-bind:error="errors.first('description')" name="description" id="description"
                data-vv-name="description" v-bind:data-vv-as="' '"
            ></z-text-area>

            <z-input 
                v-model="group.sort" v-bind:disabled="progress" label="Сортировка" 
                v-bind:error="errors.first('sort')" name="sort" id="sort" v-validate="{'required': true}"
                data-vv-name="sort" v-bind:data-vv-as="' '" type="number"
            ></z-input>
        </div>
    </entity-page>
</template>
<script>
    import ZInput      from '@/components/ZInput';
    import ZTextArea   from '@/components/ZTextArea';
    import ZIconButton from '@/components/ZIconButton.vue';
    import EntityPage  from '@/components/EntityPage.vue';
    export default {
        components: {EntityPage, ZIconButton, ZTextArea, ZInput},
        data() {
            return {
                group: {},
                groupDefault: {
                    name: null,
                    description: null,
                    sort: 100,
                    code: null
                }
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-user-group-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
        },
        watch: {
            '$route.params.group_code'(newValue, oldValue) {
                if (JSON.stringify(newValue) != JSON.stringify(oldValue)) this.init();
            }
        },
        created() {
            this.init();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            async init() {
                this.$store.commit('openRightPanel');

                if (this.$route.params.group_code && this.$route.params.group_code != 'new') await this.getGroup(this.$route.params.group_code);
                else this.group = Object.assign({}, this.groupDefault);

                if (!this.group.id || this.group.id == 'new') this.$store.commit('setTitle', 'Группы пользователей | Новая группа');
                else this.$store.commit('setTitle', ('Группы пользователей | ' + this.group.name));
            },
            /**
             * Получение группы
             */
            getGroup(code) {
                this.$store.commit('showProgressBar', 'load-user-group-card');
                return this.$store.dispatch('users/getUsersGroup', {groupCode: code})
                    .then((group) => this.group = Object.assign({},group))
                    .finally(() => this.$store.commit('hideProgressBar', 'load-user-group-card'));
            },
            /**
             * Добавление группы
             */
            postGroup() {
                this.$store.commit('showProgressBar', 'load-user-group-card');
                this.$store.dispatch('users/postGroup', this.group).then(r => {
                    if (!r) return;
                    this.$router.replace({name: 'UserGroup', params: {group_code: r.code}});
                    this.$root.$emit('reload-table', 'users-groups-list');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-user-group-card'));
            },
            /**
             * Изменение группы
             */
            putGroup() {
                this.$store.commit('showProgressBar', 'load-user-group-card');
                this.$store.dispatch('users/putGroup', this.group).then(() => {
                    this.init();
                    this.$root.$emit('reload-table', 'users-groups-list');  
                }).finally(() => this.$store.commit('hideProgressBar', 'load-user-group-card'));
            },
            /**
             * Сохранение группы
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.group_code != 'new') this.putGroup();
                    else this.postGroup();
                })
            },
            /**
             * Возврат на предидущую страницу
             */
            back() {
                this.$router.push({name: 'UserGroups', query: this.$route.query});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Group.vue?4dad697a